import { FilterConfig } from '../../../../model/filter';
import { Address, AddressGroup, Rule } from '../../../../dtos/version.dto';
import { isAddressHasRule } from 'src/utils/versionUtils';

export const addressesFiltersConfig = (addressGroups: AddressGroup[], addressRules: Rule[]): FilterConfig<Address> => {
    return {
        searchBox: { placeholder: 'Search', byFields: ['displayName', 'type', 'value', 'description']},
        multipleDropdownList: [
            {
                name: 'Groups',
                options:[
                    ...addressGroups.map(group => {
                        return { label: group.displayName, filterFn: (address: Address) => group.addresses.includes(address.id) };
                    })
                ]
            },
            {
                name: 'Rules',
                matchWidth: false,
                options: [
                    ...addressRules.map(rule => {
                        return { label: rule.displayName, filterFn: (address: Address) =>
                                isAddressHasRule(rule, address, addressGroups) };
                    })
                ]
            }
        ],
        dropdownList: [
            {
                name: 'IP Type',
                options: [
                    { label: 'All', filterFn: () => true },
                    { label: 'IPv4', filterFn: (ip: Address) => ip.ipVersion === 4 },
                    { label: 'IPv6', filterFn: (ip: Address) => ip.ipVersion === 6 }
                ]
            }
        ]
    };
};